import "./icons.scss";

type Data = {
  iconsTitle: string;
  championLogo?: string;
  icons: {
    icon: string;
    text?: string;
  }[];
};

interface Props {
  info: Data;
}

const WebDesignIcons = ({ info }: Props) => {
  return (
    <div className="web-design-icons-container">
      <div className="title-2" dangerouslySetInnerHTML={{ __html: info.iconsTitle }}></div>
      
      {info.championLogo && (
        <div className="champion-logo-container">
          <img 
            src={info.championLogo}
            alt="Champions League"
            className="champion-logo"
          />
          <div className="champion-text-overlay">
            BUN VENIT ÎN<br/>CHAMPIONS LEAGUE
          </div>
        </div>
      )}
      
      <div className="web-design-icons">
        {info.icons.map((item, index) => (
          <div className="web-design-icon-wrapper" key={index}>
            <img className={!item.text ? "bigger-icon" : ""} src={item.icon} alt={item.text || "Web design icon"} />
            <div className="body">{item.text}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WebDesignIcons;